export interface MmobileNotification {
  id: CustomNotificationId | string;
  text: string;
  url: string;
  remainOpenOnAction?: boolean;
  buttonText?: string;
  maxViews?: number;
  daysUntilNextView?: number;
  channel?: 'APP' | 'WEB';
}
export interface Notification extends MmobileNotification {
  views: number;
  dontShowUntilNextSessionSessionCounter?: number;
  btnShowLaterPressedDate?: string;
  interpolationParams?: { [key: string]: string };
}

export enum CustomNotificationId {
  NOTIFICATION_PAYMENT_PLAN = 'NOTIFICATION_PAYMENT_PLAN',
  NOTIFICATION_CAPTURE_DOCUMENT_NOT_FOUND = 'NOTIFICATION_CAPTURE_DOCUMENT_NOT_FOUND',
  NOTIFICATION_CAPTURE_DOCUMENT_ALMOST_EXPIRED = 'NOTIFICATION_CAPTURE_DOCUMENT_ALMOST_EXPIRED',
  NOTIFICATION_CAPTURE_DOCUMENT_EXPIRED = 'NOTIFICATION_CAPTURE_DOCUMENT_EXPIRED',
  NOTIFICATION_FAMILY_INVITATION_NOT_COMPLETED = 'NOTIFICATION_FAMILY_INVITATION_NOT_COMPLETED',
  NOTIFICATION_FAMILY_CREATION_PROCESS_NOT_COMPLETED = 'NOTIFICATION_FAMILY_CREATION_PROCESS_NOT_COMPLETED',
  NOTIFICATION_MULTIMAP = 'NOTIFICATION_MULTIMAP'
}

export const documentCaptureNotifications: CustomNotificationId[] = [
  CustomNotificationId.NOTIFICATION_CAPTURE_DOCUMENT_NOT_FOUND,
  CustomNotificationId.NOTIFICATION_CAPTURE_DOCUMENT_ALMOST_EXPIRED,
  CustomNotificationId.NOTIFICATION_CAPTURE_DOCUMENT_EXPIRED
];
